import FlexContainer from 'components/common/FlexContainer';
import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  margin: '120px 0px',
  textAlign: 'center',
  alignItems: 'center',
  [mobileMediaQuery]: {
    margin: '80px 20px',
  },
});

export const Header = styled.span({
  fontSize: fontStyles.sizes.xl,
});
